import { render, staticRenderFns } from "./PartnerCenter.vue?vue&type=template&id=9ffc9f14&scoped=true&"
import script from "./PartnerCenter.vue?vue&type=script&lang=js&"
export * from "./PartnerCenter.vue?vue&type=script&lang=js&"
import style0 from "./PartnerCenter.vue?vue&type=style&index=0&id=9ffc9f14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ffc9f14",
  null
  
)

export default component.exports